/**
 * Meta (Facebook) Pixel — carregamento único + PageView em SPA.
 * ID: REACT_APP_META_PIXEL_ID (definido em .env.* na raiz do quizter-front).
 */

export const META_PIXEL_ID = (process.env.REACT_APP_META_PIXEL_ID ?? '').trim();

declare global {
  interface Window {
    fbq?: MetaPixelCommand;
    _fbq?: unknown;
  }
}

type MetaPixelCommand = {
  (command: 'init', pixelId: string, options?: Record<string, unknown>): void;
  (command: 'track', eventName: string, params?: Record<string, unknown>): void;
  (command: 'trackCustom', eventName: string, params?: Record<string, unknown>): void;
};

let stubInjected = false;
let initialized = false;

function injectFbqStub(): void {
  if (typeof window === 'undefined' || stubInjected) return;
  const win = window as Window & { fbq?: unknown; _fbq?: unknown };
  if (win.fbq) {
    stubInjected = true;
    return;
  }

  // Base code oficial da Meta (fbevents.js carrega em async; fila até o script estar pronto).
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- snippet da Meta usa `arguments` e fila dinâmica
  void (function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return;
    let n: any;
    n = f.fbq = function () {
      if (n.callMethod) {
        n.callMethod.apply(n, arguments);
      } else {
        n.queue.push(arguments);
      }
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = b.createElement(e) as HTMLScriptElement;
    t.async = true;
    t.src = v;
    const s = b.getElementsByTagName(e)[0];
    s.parentNode!.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

  stubInjected = true;
}

export function isMetaPixelConfigured(): boolean {
  return META_PIXEL_ID.length > 0;
}

/** Garante stub + init uma vez por sessão (SPA). */
export function ensureMetaPixelInitialized(): void {
  if (!META_PIXEL_ID || typeof window === 'undefined') return;

  injectFbqStub();
  if (!initialized && window.fbq) {
    window.fbq('init', META_PIXEL_ID);
    initialized = true;
  }
}

/** PageView padrão — após mudança de rota o History já reflete a URL atual (React Router). */
export function trackMetaPageView(): void {
  if (!META_PIXEL_ID) return;
  ensureMetaPixelInitialized();
  window.fbq?.('track', 'PageView');
}
